<script setup>
import { ref, onMounted } from 'vue'
import { formattedDate, humanizeText, parse_notification_description, swalError, swalSuccess } from '@/helper';
import { get_trait } from '@/services/option';
import { update_notification } from '@/services/notifications';
import infoCard from './infoCard.vue'
import { onBeforeRouteLeave, useRouter } from 'vue-router';

const props = defineProps({
  notification: {
    type: Object
  }
})
const isLoading = ref(false)
const name = ref('')
onMounted(async()=>{
  isLoading.value = true
  await check_type(props.notification)
  isLoading.value = false
})

async function get_trait_name(trait_id){
  let response = await get_trait(trait_id)
  if (response.error){
    swalError(response.result.error)
    name.value = '-'
    return 
  }
  name.value = response.result.data.attributes.name
}

const isShowInfo = ref(false)
async function showInfo(){
  isShowInfo.value = !isShowInfo.value
  await mark_as_seen()
}

async function delete_notification(notification){
  let data = {seen_by_user: true}
  await mark_as_seen(notification.id, data)
  swalSuccess('Notification has been mark as seen', false, 'Update')
}

const linkData = ref({
  name: '',
  params: {}
})
const needInfo = ref(true)
const needLink = ref(false)
async function check_type(notification){
  switch (notification.entity_type.attributes.entity) {
    case "support_ticket":
      needInfo.value = false
      linkData.value.name = 'support-view'
      linkData.value.params = { id: notification.meta.id }
      needLink.value = true
      break;
    case "feedback":
      linkData.value.name = 'support-view'
      linkData.value.params = { id: notification.meta.id }
      needInfo.value = false
      needLink.value = true
      break;
    case "system_feedback":
      linkData.value.name = 'system-ticket'
      linkData.value.params = { id: notification.meta.id }
      needInfo.value = false
      needLink.value = true
      break;
    case "new_report":
      linkData.value.name = 'dna-report-single-application'
      linkData.value.params = { id: notification.meta.id }
      needInfo.value = false
      needLink.value = true
      break;
    case "update_report":
      linkData.value.name = 'dna-report-single-application'
      linkData.value.params = { id: notification.meta.id }
      needInfo.value = false
      needLink.value = true
      break;
    case "report":
      // linkData.value.name = 'system-ticket'
      // linkData.value.params = { id: notification.meta.id }
      needInfo.value = false
      break;
    case "assessment":
      needInfo.value = true
      await get_trait_name(props.notification.meta.trait_id)
      break;
    case "new_child_registration":
      linkData.value.name = 'dna-report-single-application'
      linkData.value.params = { id: notification.meta.id }
      needInfo.value = true
      needLink.value = true
      break;
    default:
      break;
  }
}

async function mark_as_seen(){
  if (!props.notification.attributes.seen_by_user){
    let response = await update_notification(props.notification.id, {seen_by_user: true})
    if (response.error){
      swalError(response.result, true)
      return
    }
    props.notification.attributes = response.result.data.data.attributes

  }
}

const router = useRouter()
async function next_page(){
  await mark_as_seen()
  router.push({name: linkData.value.name, params: linkData.value.params})
}

function get_description(){
  return parse_notification_description(props.notification)
}
</script>

<template>
  <div class="d-flex justify-content-between align-items-center" >
    <div class="col-6">
      <p class="text-secondary activity-date-top">
        {{ formattedDate(notification.attributes.created_at) }}
      </p>
      <p class="mb-0 fw-bold text-capitalize">
        {{ humanizeText(notification.entity_type.attributes.entity) }}
      </p>
      <p>
        {{ get_description() }}
        <template v-if="isLoading">
          <p class="card-text placeholder-glow">
            <span class="placeholder col-2"></span>
          </p>
        </template>
        <template v-else>
          {{ name }}
        </template>
      </p>
    </div>
    <div class="col-4 d-flex justify-content-end">
      <button class="me-2 btn icon-btn btn-light-warning" 
        @click="showInfo"
        v-if="needInfo"
      >
        <vue-feather type="more-horizontal"></vue-feather>
      </button>
      <button v-if="needLink" @click="next_page"
        class="me-2 btn icon-btn btn-light-success"
      >
        <vue-feather type="chevron-right"></vue-feather>
      </button>
      <button class="btn icon-btn btn-light-primary"
        v-if="!notification.attributes.seen_by_user"
        @click="delete_notification(notification)"
      >
        <vue-feather type="check"></vue-feather>
      </button>
    </div>
    <div class="col-2 ms-3 activity-date-side">
      <p>{{ formattedDate(notification.attributes.created_at, true) }}</p>
    </div>
  </div>
  <div v-if="isShowInfo">
    <infoCard :notification="notification"/>
  </div>
</template>